import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import { Img } from 'react-image';

const Image = styled(Img)`
  max-width: ${props => (props.theme.isPortrait ? 150 : 368)}px;
  max-height: ${props => (props.theme.isPortrait ? 205 : 503)}px;
  width: ${props => (props.theme.isPortrait ? 'auto' : '25vw')};
  height: ${props => (props.theme.isPortrait ? '55vw' : '34vw')};
  margin-top: ${props => (props.theme.isPortrait ? 40 : 0)}px;
`;

export default function Cover() {
  const { cover } = React.useContext(ThemeContext);

  return <Image src={cover} />;
}
